export default {
  en: {
    TimeRecordingIndexScene: {
      title: '[Preview] Time tracking',
      addNew: 'Add new',
    },
  },
};
